/* eslint-disable react-refresh/only-export-components */
// src/config/antd.js

import {
  Button,
  Form,
  Input,
  InputNumber,
  Select,
  Slider,
  DatePicker,
  Table,
  Modal,
  Layout,
  Menu,
  Breadcrumb,
  Card,
  Spin,
  Checkbox,
  Radio,
  Tabs,
  Tooltip,
  Popconfirm,
  Drawer,
  Avatar,
  Typography,
  Steps,
  Upload,
  Switch,
  Dropdown,
  Pagination,
  Space,
  message,
  Progress,
  Collapse,
  Badge,
  Tag,
  Alert

  // Add any other Ant Design components you plan to use
} from "antd";

// New SVG Navigation Icon imports
import campaignDefault from "@/assets/icons/nav_Icons/campaign_default.svg";
import campaignHover from "@/assets/icons/nav_Icons/campaign_hover.svg";
import candidatesDefault from "@/assets/icons/nav_Icons/candidates_default.svg";
import candidatesHover from "@/assets/icons/nav_Icons/candidates_hover.svg";
import canvassDefault from "@/assets/icons/nav_Icons/canvass_default.svg";
import canvassHover from "@/assets/icons/nav_Icons/canvass_hover.svg";
import financeDefault from "@/assets/icons/nav_Icons/finance_default.svg";
import financeHover from "@/assets/icons/nav_Icons/finance_hover.svg";
import helpDefault from "@/assets/icons/nav_Icons/help_default.svg";
import helpHover from "@/assets/icons/nav_Icons/help_hover.svg";
import homeDefault from "@/assets/icons/nav_Icons/home_default.svg";
import homeHover from "@/assets/icons/nav_Icons/home_hover.svg";
import manifestoDefault from "@/assets/icons/nav_Icons/manifesto_default.svg";
import manifestoHover from "@/assets/icons/nav_Icons/manifesto_hover.svg";
import mediaDefault from "@/assets/icons/nav_Icons/media_default.svg";
import mediaHover from "@/assets/icons/nav_Icons/media_hover.svg";
import pollsDefault from "@/assets/icons/nav_Icons/political_default.svg";
import pollsHover from "@/assets/icons/nav_Icons/political_hover.svg";
import rolesDefault from "@/assets/icons/nav_Icons/roles_default.svg";
import rolesHover from "@/assets/icons/nav_Icons/roles_hover.svg";
import settingsDefault from "@/assets/icons/nav_Icons/settings_default.svg";
import settingsHover from "@/assets/icons/nav_Icons/settings_hover.svg";
import supportDefault from "@/assets/icons/nav_Icons/support_default.svg";
import supportHover from "@/assets/icons/nav_Icons/support_hover.svg";
import townhallDefault from "@/assets/icons/nav_Icons/townhall_default.svg";
import townhallHover from "@/assets/icons/nav_Icons/townhall_hover.svg";
import usersDefault from "@/assets/icons/nav_Icons/users_default.svg";
import usersHover from "@/assets/icons/nav_Icons/users_hover.svg";

// NEW SVG WEB ICONS
import BreadcrumbHome from "@/assets/icons/web_Icons/home_2.svg";
import messageText from "@/assets/icons/web_Icons/message-text.svg";
import messageText2 from "@/assets/icons/web_Icons/message-text-2.svg";
import settingsBell from "@/assets/icons/web_Icons/settings_bell.svg";
import settingsBrush from "@/assets/icons/web_Icons/settings_brush.svg";
import settingsEssentials1 from "@/assets/icons/web_Icons/settings_essentials_1.svg";
import settingsFacebook from "@/assets/icons/web_Icons/settings_facebook.svg";
import settingsFile from "@/assets/icons/web_Icons/settings_file.svg";
import settingsGear from "@/assets/icons/web_Icons/settings_gear.svg";
import settingsLogout from "@/assets/icons/web_Icons/settings_logout.svg";
import settingsMessage from "@/assets/icons/web_Icons/settings_message.svg";
import Lock from "@/assets/icons/web_Icons/lock.svg";
import Profile from "@/assets/icons/web_Icons/profile.svg";
import UserInvite from "@/assets/icons/web_Icons/user_invite.svg";
import Camera from "@/assets/icons/web_Icons/camera.svg";
import CallCalling from "@/assets/icons/web_Icons/call-calling.svg";
import Location from "@/assets/icons/web_Icons/location.svg";
import Money from "@/assets/icons/web_Icons/money.svg";
import Wallet from "@/assets/icons/web_Icons/wallet.svg";
import Gear from "@/assets/icons/web_Icons/gear.svg";
import ContentEdit from "@/assets/icons/web_Icons/content_edit.svg";
import ContentEdit2 from "@/assets/icons/web_Icons/content_edit_2.svg";
import Calender from "@/assets/icons/web_Icons/calender_1.svg";
import CalenderFilled from "@/assets/icons/web_Icons/calender_filled.svg";
import Calendar2 from "@/assets/icons/web_Icons/calendar_2.svg";
import CalendarSearch from "@/assets/icons/web_Icons/calender_search.svg";
import Edit1 from "@/assets/icons/web_Icons/edit.svg";
import Edit from "@/assets/icons/web_Icons/edit_1.svg";
import Download from "@/assets/icons/web_Icons/download.svg";
import Trash from "@/assets/icons/web_Icons/trash_1.svg";
import TwinMessage from "@/assets/icons/web_Icons/twin_message.svg";
import Call from "@/assets/icons/web_Icons/call.svg";
import Text from "@/assets/icons/web_Icons/text.svg";
import FilledEdit from "@/assets/icons/web_Icons/filled_edit.svg";
import FilledTrash from "@/assets/icons/web_Icons/filled_trash.svg";
import ArrowDown from "@/assets/icons/web_Icons/arrow-down.svg";
import ArrowLeft from "@/assets/icons/web_Icons/arrow_left.svg";
import ArrowRight from "@/assets/icons/web_Icons/arrow_right.svg";
import LongArrowUp from "@/assets/icons/web_Icons/long_arrow_up.svg";
import LongArrowDown from "@/assets/icons/web_Icons/long_arrow_down.svg";
import LongTwoWayArrow from "@/assets/icons/web_Icons/long_two_way_arrow.svg";
import UserGroupedFilled from "@/assets/icons/web_Icons/user_grouped_filled.svg";
import UploadSVG from "@/assets/icons/web_Icons/upload.svg";
import ReplySVG from "@/assets/icons/web_Icons/reply.svg";
import Google from "@/assets/icons/web_Icons/google.svg";
import Facebook from "@/assets/icons/web_Icons/facebook.svg";
import Support from "@/assets/icons/web_Icons/support.svg";
import TicketExpired from "@/assets/icons/web_Icons/ticket_expired.svg";
import Trash2 from "@/assets/icons/web_Icons/trash_2.svg";
import ReplyFilled from "@/assets/icons/web_Icons/reply_filled.svg";
import Export from "@/assets/icons/web_Icons/export.svg";
import PDF from "@/assets/icons/web_Icons/pdf.svg";
import Cup from "@/assets/icons/web_Icons/cup.svg";
import Watch from "@/assets/icons/web_Icons/watch.svg";
import Star from "@/assets/icons/web_Icons/star.svg";
import Clock from "@/assets/icons/web_Icons/clock.svg";
import Send2 from "@/assets/icons/web_Icons/send_2.svg";
import Check from "@/assets/icons/web_Icons/check.svg";
import Verify from "@/assets/icons/web_Icons/verify.svg";
import CallBg from "@/assets/icons/web_Icons/call-bg.svg";
import IconCall from "@/assets/icons/web_Icons/icon-call.svg";
import EditBg from "@/assets/icons/web_Icons/edit-bg.svg";
import MessageBg from "@/assets/icons/web_Icons/message-bg.svg";
import Message2Bg from "@/assets/icons/web_Icons/message2-bg.svg";
import LocationBg from "@/assets/icons/web_Icons/location-bg.svg";
import ImageUpload from "@/assets/icons/web_Icons/image_upload.svg";
import DocumentUpload from "@/assets/icons/web_Icons/document_upload.svg";
import VideoUpload from "@/assets/icons/web_Icons/video_upload.svg";
import VideoPlayer from "@/assets/icons/web_Icons/video_player.svg";

// Notification Icons
import SmsNotification from "@/assets/icons/web_Icons/sms_notification.svg";
import StarNotification from "@/assets/icons/web_Icons/star_notification.svg";
import NotificationBing from "@/assets/icons/web_Icons/notification_bing.svg";
import NotificationBing2 from "@/assets/icons/web_Icons/notification_bing_2.svg";

// Blue Filled Icons
import DocumentCode from "@/assets/icons/web_Icons/blue_filled_icons/document_code.svg";
import DocumentDownload from "@/assets/icons/web_Icons/blue_filled_icons/document_download.svg";
import BlueEdit from "@/assets/icons/web_Icons/blue_filled_icons/edit.svg";
import BlueTrash from "@/assets/icons/web_Icons/blue_filled_icons/trash.svg";
import BlueTrashRed from "@/assets/icons/web_Icons/blue_filled_icons/trash_red.svg";
import BlueCalendar from "@/assets/icons/web_Icons/blue_filled_icons/calendar.svg";
import BlueTrashFilled from "@/assets/icons/web_Icons/blue_filled_icons/trash_filled.svg";
import BlueModify from "@/assets/icons/web_Icons/blue_filled_icons/modify.svg";
import BlueDayMode from "@/assets/icons/web_Icons/blue_filled_icons/day_mode.svg";
import BlueNightMode from "@/assets/icons/web_Icons/blue_filled_icons/night_mode.svg";
import BlueSystemDefault from "@/assets/icons/web_Icons/blue_filled_icons/system_default.svg";
import BlueLocation from "@/assets/icons/web_Icons/blue_filled_icons/location.svg";
import BlueVideo from "@/assets/icons/web_Icons/blue_filled_icons/video.svg";
import BlueCancel from "@/assets/icons/web_Icons/blue_filled_icons/cancel.svg";
import BlueCopy from "@/assets/icons/web_Icons/blue_filled_icons/copy.svg";

// If you're using icons, import them here as well
import {
  UserOutlined,
  DashboardOutlined,
  SettingOutlined,
  CalendarOutlined,
  TeamOutlined,
  SoundOutlined,
  BarChartOutlined,
  PictureOutlined,
  DollarOutlined,
  LockOutlined,
  CloseOutlined,
  MenuOutlined,
  HomeOutlined,
  SearchOutlined,
  ArrowRightOutlined,
  MailOutlined,
  CameraOutlined,
  EditOutlined,
  ContactsOutlined,
  FormOutlined,
  DownOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
  CheckOutlined,
  CheckCircleOutlined,
  UploadOutlined,
  TrophyOutlined,
  FilePdfOutlined,
  DownloadOutlined,
  PlusOutlined,
  ReloadOutlined,
  MoreOutlined,
  RightOutlined,
  LeftOutlined,
  DeleteOutlined,
  ArrowLeftOutlined,
  EnvironmentOutlined,
  SmileOutlined,
  LinkOutlined,
  ClockCircleOutlined,
  VideoCameraOutlined,
  EllipsisOutlined,
  LaptopOutlined,
  CopyOutlined,
  ShareAltOutlined,
  GlobalOutlined,
  UserAddOutlined,
  DisconnectOutlined,
  CaretDownOutlined,
  // TrendingUpOutlined
  // Add other icons as needed
} from "@ant-design/icons";

export {
  Button,
  Form,
  Input,
  InputNumber,
  Select,
  Slider,
  DatePicker,
  Table,
  Modal,
  Layout,
  Menu,
  Breadcrumb,
  Card,
  Spin,
  Checkbox,
  Radio,
  Tabs,
  Tooltip,
  Popconfirm,
  Drawer,
  Avatar,
  Typography,
  Steps,
  Upload,
  Switch,
  Dropdown,
  Pagination,
  Space,
  message,
  Progress,
  Collapse,
  Badge,
  Tag,
  Alert,

  // Export the icons
  UserOutlined,
  DashboardOutlined,
  SettingOutlined,
  CalendarOutlined,
  TeamOutlined,
  SoundOutlined,
  BarChartOutlined,
  PictureOutlined,
  DollarOutlined,
  LockOutlined,
  CloseOutlined,
  MenuOutlined,
  HomeOutlined,
  SearchOutlined,
  ArrowRightOutlined,
  MailOutlined,
  CameraOutlined,
  EditOutlined,
  ContactsOutlined,
  FormOutlined,
  DownOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
  CheckOutlined,
  CheckCircleOutlined,
  UploadOutlined,
  TrophyOutlined,
  FilePdfOutlined,
  DownloadOutlined,
  PlusOutlined,
  ReloadOutlined,
  MoreOutlined,
  RightOutlined,
  LeftOutlined,
  ArrowLeftOutlined,
  DeleteOutlined,
  EnvironmentOutlined,
  SmileOutlined,
  LinkOutlined,
  ClockCircleOutlined,
  VideoCameraOutlined,
  EllipsisOutlined,
  LaptopOutlined,
  CopyOutlined,
  ShareAltOutlined,
  GlobalOutlined,
  UserAddOutlined,
  DisconnectOutlined,
  CaretDownOutlined,
  // TrendingUpOutlined
};

// New Navigation Icons export
export const NavIcons = {
  Campaign: {
    default: campaignDefault,
    hover: campaignHover,
  },
  Candidates: {
    default: candidatesDefault,
    hover: candidatesHover,
  },
  Canvass: {
    default: canvassDefault,
    hover: canvassHover,
  },
  Finance: {
    default: financeDefault,
    hover: financeHover,
  },
  Help: {
    default: helpDefault,
    hover: helpHover,
  },
  Home: {
    default: homeDefault,
    hover: homeHover,
  },
  Manifesto: {
    default: manifestoDefault,
    hover: manifestoHover,
  },
  Media: {
    default: mediaDefault,
    hover: mediaHover,
  },
  Polls: {
    default: pollsDefault,
    hover: pollsHover,
  },
  Roles: {
    default: rolesDefault,
    hover: rolesHover,
  },
  Settings: {
    default: settingsDefault,
    hover: settingsHover,
  },
  Support: {
    default: supportDefault,
    hover: supportHover,
  },
  Townhall: {
    default: townhallDefault,
    hover: townhallHover,
  },
  Users: {
    default: usersDefault,
    hover: usersHover,
  },
};

// NEW SVG WEB ICONS EXPORTS
export const WebIcons = {
  BreadcrumbHome: BreadcrumbHome,
  Message: messageText,
  Message2: messageText2,
  CandidatesHover: candidatesHover,
  CanvassHover: canvassHover,
  TownHallHover: townhallHover,
  ManifestoHover: mediaHover,
  CampaignHover: campaignHover,
  FinancialHover: financeHover,
  UserHover: usersHover,
  RoleHover: rolesHover,
  SupportHover: supportHover,
  PollsHover: pollsHover,
  SettingsBell: settingsBell,
  SettingsBrush: settingsBrush,
  SettingsEssentials1: settingsEssentials1,
  SettingsFacebook: settingsFacebook,
  SettingsFile: settingsFile,
  SettingsGear: settingsGear,
  SettingsLogout: settingsLogout,
  SettingsMessage: settingsMessage,
  Lock: Lock,
  Profile: Profile,
  UserInvite: UserInvite,
  Camera: Camera,
  CallCalling: CallCalling,
  Location: Location,
  Money: Money,
  Wallet: Wallet,
  Gear: Gear,
  ContentEdit: ContentEdit,
  ContentEdit2: ContentEdit2,
  Calender: Calender,
  CalenderFilled: CalenderFilled,
  Calendar2: Calendar2,
  CalendarSearch: CalendarSearch,
  Edit1: Edit1,
  Edit: Edit,
  Download: Download,
  Trash: Trash,
  TwinMessage: TwinMessage,
  Call: Call,
  Text: Text,
  FilledEdit: FilledEdit,
  FilledTrash: FilledTrash,
  ArrowDown: ArrowDown,
  ArrowLeft: ArrowLeft,
  ArrowRight: ArrowRight,
  LongArrowUp: LongArrowUp,
  LongArrowDown: LongArrowDown,
  LongTwoWayArrow: LongTwoWayArrow,
  UserGroupedFilled: UserGroupedFilled,
  Upload: UploadSVG,
  Reply: ReplySVG,
  Google: Google,
  Facebook: Facebook,
  Support: Support,
  ExpiredTicket: TicketExpired,
  Trash2: Trash2,
  ReplyFilled: ReplyFilled,
  Export: Export,
  PDF: PDF,
  Cup: Cup,
  Watch: Watch,
  Star: Star,
  Clock: Clock,
  Send2: Send2,
  Check: Check,
  Verify: Verify,
  CallBg: CallBg,
  IconCall: IconCall,
  EditBg: EditBg,
  MessageBg: MessageBg,
  Message2Bg: Message2Bg,
  LocationBg: LocationBg,
  DocumentUpload: DocumentUpload,
  ImageUpload: ImageUpload,
  VideoUpload: VideoUpload,
  VideoPlayer: VideoPlayer,

  // Notification Icons
  SmsNotification: SmsNotification,
  StarNotification: StarNotification,
  NotificationBing: NotificationBing,
  NotificationBing2: NotificationBing2,

  // Blue filled icons
  DocumentCode: DocumentCode,
  DocumentDownload: DocumentDownload,
  BlueEdit: BlueEdit,
  BlueTrash: BlueTrash,
  BlueTrashRed: BlueTrashRed,
  BlueCalendar: BlueCalendar,
  BlueTrashFilled: BlueTrashFilled,
  BlueModify: BlueModify,
  BlueDayMode: BlueDayMode,
  BlueNightMode: BlueNightMode,
  BlueSystemDefault: BlueSystemDefault,
  BlueVideo: BlueVideo,
  BlueLocation: BlueLocation,
  BlueCancel: BlueCancel,
  BlueCopy: BlueCopy,
};

export const PrimaryButton = (props) => <Button type="primary" {...props} />;
export const DangerButton = (props) => (
  <Button type="primary" danger {...props} />
);

// Add any other custom components or utilities related to Ant Design here

// Logo imports
import cmsStandaloneLogo from "@/assets/icons/Logos/cms_standalone_logo.png";
import cmsLogo from "@/assets/icons/Logos/cms_logo.png";
import VeegilLogo from "@/assets/icons/web_Icons/veegil_logo.svg";

// Logo exports
export const Logos = {
  CMSStandaloneLogo: cmsStandaloneLogo,
  CMSLogo: cmsLogo,
  VeegilLogo: VeegilLogo,
};
